import React from "react";
import { Shield, Award, CheckCircle, Phone, FileText, Heart } from "lucide-react";
import Reveal from "../Reveal";

const REASONS = [
  { icon: Shield, title: "Residential Lifetime Warranty", desc: "We stand behind our polyaspartic coatings for as long as you own your home. No peeling, fading or hot-tire pickup." },
  { icon: Award, title: "Industrial-Grade Preparation", desc: "Planetary diamond grinders open the concrete pores for a permanent molecular bond — the step others skip." },
  { icon: CheckCircle, title: "Local, Not a Franchise", desc: "Based right here in Prescott. No franchise fees, no call centers. You deal directly with Tyler." },
  { icon: Phone, title: "Fast, Honest Communication", desc: "We answer the phone, show up on time and tell you the truth about your project — every time." },
  { icon: FileText, title: "Transparent Free Estimates", desc: "Clear, written quotes with no surprises and no high-pressure sales tactics." },
  { icon: Heart, title: "We Treat Your Home With Respect", desc: "Inviting someone onto your property is an act of trust. We never take that lightly." },
];

const WhyChooseUs = () => (
  <section className="py-20 md:py-24 bg-[#0A0A0A]" data-testid="why-choose-section">
    <div className="max-w-7xl mx-auto px-5 lg:px-12">
      <div className="text-center max-w-3xl mx-auto mb-14">
        <span className="text-[#C69453] text-sm font-semibold tracking-[0.2em] uppercase">Why Choose Pryme Epoxy</span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-white mt-2 leading-tight">
          The PRYME Standard: Never Cutting Corners
        </h2>
        <p className="text-zinc-400 text-base md:text-lg mt-4">
          Buying a new floor is a real investment. Here's why Northern Arizona homeowners trust us to get it right the first time.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
        {REASONS.map((r, i) => (
          <Reveal key={r.title} delay={(i % 3) * 0.06}>
            <div className="border border-zinc-800 bg-[#141414] p-8 relative h-full">
              <div className="absolute top-0 left-0 w-full h-1 bg-[#C69453]" />
              <div className="w-12 h-12 bg-[#C69453]/10 border border-[#C69453]/30 flex items-center justify-center text-[#C69453] mb-6">
                <r.icon className="w-6 h-6" />
              </div>
              <h3 className="text-xl md:text-2xl font-semibold text-white">{r.title}</h3>
              <p className="text-zinc-400 text-base mt-3 leading-relaxed">{r.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseUs;
